import { Component } from 'react';
import { connect } from 'react-redux';
import { getVuoadminLoginReasons } from 'shared-helpers/common';
import api from 'api';
import { actions } from 'store';
import { Alert, Button } from 'components/common';
import { Form, FormGroup, Select, Text } from 'components/common/form';

const VuoadminLogin = connect((state) => state)(
  class extends Component {
    componentDidMount() {
      this.inputContainer.querySelector('input').focus();
    }

    handleSubmit = async (values) => {
      const { dispatch, messages } = this.props;

      try {
        dispatch(actions.updatePageState({ loading: true }));
        const reasonOptions = getVuoadminLoginReasons(messages);
        await api.post('/auth/vuoadmin/request-link', {
          email: values.email,
          reason: values.reason,
          reasonText: reasonOptions[values.reason]
        });
        dispatch(actions.updatePageState({ loading: false, success: true }));
      } catch (err) {
        dispatch(actions.updatePageState({ loading: false }));
        await dispatch.handleErrorDispatch(err);
      }
    };

    validateEmail = (value) => {
      const { messages } = this.props;

      const emailRegex = /^vuoadmin\..+@vuolearning\.fi$/g;
      const valid = value?.trim()?.match(emailRegex);

      return valid ? undefined : messages.authVuoadminLoginInvalidEmail;
    };

    render() {
      const {
        messages,
        pageState: { loading, success }
      } = this.props;

      const reasonOptions = getVuoadminLoginReasons(messages);

      const initialValues = { reason: 'user-management' };

      return (
        <div className="login-form">
          <Form initialValues={initialValues} onSubmit={this.handleSubmit}>
            {({ formState }) => (
              <>
                <FormGroup htmlFor="email" label={messages.commonEmail}>
                  <Text
                    field="email"
                    id="email"
                    inputContainerRef={(el) => (this.inputContainer = el)}
                    placeholder="vuoadmin.user@vuolearning.fi"
                    validate={this.validateEmail}
                    validateOnChange={true}
                  />
                </FormGroup>

                <FormGroup
                  htmlFor="reason"
                  label={messages.authVuoadminLoginReason}
                >
                  <Select
                    field="reason"
                    id="reason"
                    options={Object.keys(reasonOptions).map((key) => ({
                      label: reasonOptions[key],
                      value: key
                    }))}
                  />
                </FormGroup>

                <Button
                  category="success"
                  disabled={
                    !formState.values.email || formState.invalid || success
                  }
                  loading={loading}
                  text={messages.authVuoadminLoginSend}
                  type="submit"
                />

                {success ? (
                  <Alert
                    className="login-success"
                    text={messages.authVuoadminLoginSuccess}
                    type="success-light"
                  />
                ) : null}
              </>
            )}
          </Form>

          <style jsx>{`
            .login-form :global(button) {
              margin-top: 20px;
              width: 100%;
            }
            .login-form :global(.login-error),
            .login-form :global(.login-success) {
              margin-top: 20px;
            }
          `}</style>
        </div>
      );
    }
  }
);

export default VuoadminLogin;
